import Vue from 'vue';

import rutMask from '@/library/directivas/rutMask.js';
Vue.directive('rut-mask', rutMask)